import {NgModule} from "@angular/core";
import {CoreModule} from "./core/core.module";
import {SharedModule} from "./shared/shared.module";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {HeaderComponent} from "./layout/header/header.component";
import {PageLoaderComponent} from "./layout/page-loader/page-loader.component";
import {SidebarComponent} from "./layout/sidebar/sidebar.component";
import {RightSidebarComponent} from "./layout/right-sidebar/right-sidebar.component";
import {AuthLayoutComponent} from "./layout/app-layout/auth-layout/auth-layout.component";
import {MainLayoutComponent} from "./layout/app-layout/main-layout/main-layout.component";
import {ErrorInterceptor} from "./helpers/interceptor/error.interceptor";
import {JwtInterceptor} from "./helpers/interceptor/jwt.interceptor";
import {LocationStrategy, HashLocationStrategy} from "@angular/common";
import {NgxSpinnerModule} from "ngx-spinner";
import {MatBadgeModule} from '@angular/material/badge';
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
import {TranslateModule, TranslateLoader} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {ClickOutsideModule} from "ng-click-outside";
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";
import {WINDOW_PROVIDERS} from "./core/service/window.service";
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from "ng-recaptcha";
import {JwtHelperService, JWT_OPTIONS} from "@auth0/angular-jwt";
import {QuillModule} from 'ngx-quill'
import {JwtModule} from "@auth0/angular-jwt";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ReportsModule} from "./reports/reports.module";
import {environment} from "src/environments/environment";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false,
};

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

import {SocketIoModule, SocketIoConfig} from 'ngx-socket-io';

const config: SocketIoConfig = {
  url: environment.serverUrl, options: {
    transports: ['websocket', 'polling']
  }
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    PageLoaderComponent,
    SidebarComponent,
    RightSidebarComponent,
    AuthLayoutComponent,
    MainLayoutComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MatBadgeModule,
    PerfectScrollbarModule,
    NgxSpinnerModule.forRoot(),
    ClickOutsideModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    CoreModule,
    SharedModule,
    RecaptchaV3Module,
    QuillModule.forRoot(),
    JwtModule,
    ReportsModule,
    SocketIoModule.forRoot(config)

  ],
  providers: [
    MatSnackBar,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true},
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
    WINDOW_PROVIDERS,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },

    {provide: JWT_OPTIONS, useValue: JWT_OPTIONS},
    JwtHelperService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
